module.exports = __webpack_public_path__ + "media/6.a4af0761.wav";